import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

export const getProductDetailsApi = async (id) => {
  try {
    return await get(`get_product_detail/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitPurchaseRequestAPI = async (body) => {
  try {
    return await post("purchase_request", body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response?.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updatePOAPI = async (id, body) => {
  try {
    return await put(`purchase_order/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response?.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getPOEditApi = async (id) => {
  try {
    return await get(`purchase_order/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getVendorProductDetailsApi = async (body) => {
  try {
    return await post("get_purchase_request_vendor", body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response?.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getPRDetailsApi = async (id) => {
  try {
    return await get(`purchase_request/view/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const updateStatusApi = async (id, bodyData) => {
  try {
    const response = await put(`status_update/${id}`, bodyData);
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response?.data ?? { success: false, message: err.message };
  }
};

export const getPurchaseReqListApi = async (params) => {
  try {
    return await get("purchase_request", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const deleteVendorApi = async (id) => {
  try {
    return await del(`vendor/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getStatusApi = async (params) => {
  try {
    return await get("get_pr_stages", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const updateStageApi = async (id, bodyData) => {
  try {
    return await put(`status_update/${id}`, bodyData);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
